export const PRODUCT_INTERACTIONS = [
  {
    value: 'APP',
    label: 'APP',
  },
  {
    value: 'PAY',
    label: 'PAY',
  },
  {
    value: 'ONRAMP',
    label: 'ONRAMP',
  },
];
